import type { Ref } from 'vue'
import { getMenuItemName as getMenuItemNameUtil, getMenuItemCategory as getMenuItemCategoryUtil } from '@/utils/priceHelpers'

interface MenuItemLike {
  id: number | string
  name?: string
  category?: { name: string } | string
}

export function useMenuItemDisplayHelpers(menuItems: Ref<MenuItemLike[]>) {
  const getMenuItemName = (menuItemId: number): string => {
    return getMenuItemNameUtil(menuItems.value, menuItemId)
  }

  const getMenuItemCategory = (menuItemId: number): string => {
    return getMenuItemCategoryUtil(menuItems.value, menuItemId)
  }

  return {
    getMenuItemName,
    getMenuItemCategory
  }
}
